module.exports = __webpack_public_path__ + "img/edit.2bba2748.svg";